module.exports = __webpack_public_path__ + "img/import.1a4b1117.svg";